import { useState } from "react";
import AgentResponseLayout from "../../../components/agent/AgentResponseLayout";
import SelectInput from "../../../components/forms/SelectInput";
import MultiSelectInput from "../../../components/forms/MultiSelectInput";
import NotesField from "../../../components/forms/NotesField";
import { useAgentResponse } from "../../../js/hooks/useAgentResponse";
import {
  DRIVEWAY_OPTIONS,
  FENCING_OPTIONS,
  GARAGE_OPTIONS,
  HOA_OPTIONS,
  LANDSCAPING_OPTIONS,
  LOT_TYPE_OPTIONS,
  SETTING_OPTIONS,
  TERRAIN_OPTIONS,
  YARD_SIZE_OPTIONS,
} from "../../../js/utils/agentResponseOptions";

export default function AgentResponseLocation() {
  const { response, saveSection, goBack, goNext } = useAgentResponse("locationLot");
  const saved = response?.locationLot || {};
  const [form, setForm] = useState(null);

  const current = form || saved;

  function update(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...(prev || saved), [name]: value }));
  }

  async function handleContinue() {
    await saveSection(current);
    goNext();
  }

  if (!response) {
    return (
      <AgentResponseLayout title="Location & Lot" onBack={goBack} onContinue={() => {}}>
        <p>Loading response…</p>
      </AgentResponseLayout>
    );
  }

  return (
    <AgentResponseLayout
      response={response}
      sectionKey="locationLot"
      title="Location & Lot"
      lead="Record how this property sits on the land — setting, lot, yard, parking, and HOA — so it can be compared to the buyer’s checklist."
      onBack={goBack}
      onContinue={handleContinue}
    >
      <section className="checklist-section">
        <h2>Setting & Lot</h2>
        <SelectInput label="Setting" name="setting" value={current.setting} onChange={update} options={SETTING_OPTIONS} />
        <MultiSelectInput label="Lot type" name="lotType" values={current.lotType || []} onChange={update} options={LOT_TYPE_OPTIONS} />
        <SelectInput label="Yard size" name="yardSize" value={current.yardSize} onChange={update} options={YARD_SIZE_OPTIONS} />
        <SelectInput
          label="Landscaping"
          name="landscaping"
          value={current.landscaping}
          onChange={update}
          options={LANDSCAPING_OPTIONS}
        />
      </section>
      <section className="checklist-section">
        <h2>Parking, Fence & HOA</h2>
        <MultiSelectInput label="Fencing" name="fencing" values={current.fencing || []} onChange={update} options={FENCING_OPTIONS} />
        <MultiSelectInput label="Driveway" name="driveway" values={current.driveway || []} onChange={update} options={DRIVEWAY_OPTIONS} />
        <SelectInput label="Garage" name="garage" value={current.garage} onChange={update} options={GARAGE_OPTIONS} />
        <SelectInput label="HOA" name="hoa" value={current.hoa} onChange={update} options={HOA_OPTIONS} />
        <MultiSelectInput label="Terrain & site notes" name="terrain" values={current.terrain || []} onChange={update} options={TERRAIN_OPTIONS} />
        <NotesField
          label="Location & lot notes"
          name="notes"
          value={current.notes}
          onChange={update}
          placeholder="Views, drainage, setbacks, ADU potential, or anything the buyer asked about the land."
        />
      </section>
    </AgentResponseLayout>
  );
}
